import React from 'react';
import { 
  FiSettings, 
  FiSave, 
  FiDatabase, 
  FiMail, 
  FiMessageSquare, 
  FiKey, 
  FiPenTool
} from 'react-icons/fi';

const Settings = () => {
  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    bg: '#f8fafc'
  };

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="mb-8">
        <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>सेटिंग्ज (Settings)</h1>
        <p className="text-gray-600 text-sm">प्रणाली कॉन्फिगरेशन आणि व्यवस्थापन.</p>
      </div>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Column: Navigation/Sections */}
        <div className="w-full lg:w-64 flex-shrink-0 space-y-2">
           <button className="w-full text-left px-4 py-3 rounded-lg bg-teal-50 text-teal-800 font-medium border border-teal-100 shadow-sm flex items-center">
             <FiSettings className="mr-3" /> सामान्य सेटिंग्ज
           </button>
           <button className="w-full text-left px-4 py-3 rounded-lg bg-white text-gray-600 font-medium border border-gray-100 hover:bg-gray-50 flex items-center transition-colors">
             <FiMessageSquare className="mr-3" /> SMS API
           </button>
           <button className="w-full text-left px-4 py-3 rounded-lg bg-white text-gray-600 font-medium border border-gray-100 hover:bg-gray-50 flex items-center transition-colors">
             <FiMail className="mr-3" /> ईमेल सर्व्हर
           </button>
           <button className="w-full text-left px-4 py-3 rounded-lg bg-white text-gray-600 font-medium border border-gray-100 hover:bg-gray-50 flex items-center transition-colors">
             <FiPenTool className="mr-3" /> डिजिटल स्वाक्षरी
           </button>
           <button className="w-full text-left px-4 py-3 rounded-lg bg-white text-gray-600 font-medium border border-gray-100 hover:bg-gray-50 flex items-center transition-colors">
             <FiDatabase className="mr-3" /> बॅकअप आणि रिस्टोर
           </button>
        </div>

        {/* Right Column: Content */}
        <div className="flex-1 space-y-6">
          
          {/* General Settings */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <h3 className="text-lg font-bold text-gray-800 mb-4 border-b pb-2 flex items-center">
               <FiSettings className="mr-2" /> प्रणाली कॉन्फिगरेशन
             </h3>
             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">आर्थिक वर्ष (सध्याचे)</label>
                  <select className="w-full p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500">
                    <option>२०२५-२०२६</option>
                    <option>२०२४-२०२५</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">भाषा (बायफॉल्ट)</label>
                  <select className="w-full p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500">
                    <option>मराठी</option>
                    <option>English</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">कर भरणा अंतिम तारीख</label>
                  <input type="date" className="w-full p-2.5 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
                <div className="flex items-end">
                  <div className="flex items-center h-10 space-x-2">
                     <input type="checkbox" id="maintenance" className="w-4 h-4 text-teal-600 rounded focus:ring-teal-500" />
                     <label htmlFor="maintenance" className="text-gray-700 font-medium">देखभाल मोड (Maintenance Mode) सक्षम करा</label>
                  </div>
                </div>
             </div>
             <div className="mt-6 flex justify-end">
                <button className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors flex items-center">
                  <FiSave className="mr-2" /> बदल जतन करा
                </button>
             </div>
          </div>

          {/* Backup Section */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <h3 className="text-lg font-bold text-gray-800 mb-4 border-b pb-2 flex items-center">
               <FiDatabase className="mr-2" /> डेटाबेस बॅकअप
             </h3>
             <p className="text-gray-600 text-sm mb-4">
               सुरक्षिततेसाठी नियमितपणे डेटाबेसचा बॅकअप घ्या. स्वयंचलित बॅकअप दररोज रात्री १२ वाजता घेण्यात येतो.
             </p>
             <div className="flex items-center gap-4 bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="flex-1">
                   <p className="font-bold text-gray-800">शेवटचा बॅकअप:</p>
                   <p className="text-sm text-green-600 font-medium">२० फेब्रुवारी २०२६, ०३:०० पहाटे (यशस्वी)</p>
                </div>
                <button className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm flex items-center">
                  <FiDatabase className="mr-2" /> आता बॅकअप घ्या (Backup Now)
                </button>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
